import React from 'react';
import { Icon, Popover } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { configService } from 'Services';
import styles from './MissingCustomListError.css';

interface CustomListType {
    listName: string;
    listType: string;
}

type Props = {
    customListType?: CustomListType;
};

const MissingCustomListError = ({ customListType }: Props) => {
    const { t } = useTranslation();
    const configCustomList = configService.customListTypes;
    const isValidListType = configCustomList?.some(
        (item: ConfigCustomListObj) => item.customListType === customListType?.listType
    );

    if (isValidListType) {
        return null;
    }

    return (
        <Popover
            showOnHover
            showArrow
            position='top'
            content={t('MissingListTypeInConfig')}
            contentClassName={styles.missingPopOverContentStyle}
            arrowClassName={styles.missingPopOverArrowStyle}
        >
            <div>
                <Icon name='small-error' size='sm' />
            </div>
        </Popover>
    );
};

export default React.memo(MissingCustomListError);
